import React from 'react';

export default function If({
  condition = false,
  children,
}) {
  return <>
    {condition ? children : null}
  </>;
}
